import { useState } from 'react';

import { convertFormToPdf } from 'components/practice/charts/ClinicalNote/Orders/lib/handleSendReferralAsFax';
import SendFaxModal from 'components/practice/comms_center/fax/components/SendFaxModal/SendFaxModal';
import Button from 'components/shared/Buttons/Button';

const SendFaxButton = ({ activeView, patient }) => {
  const [faxLoading, setFaxLoading] = useState(false);
  const [sendFaxModalVisible, setSendFaxModalVisible] = useState(false);
  const [faxData, setFaxData] = useState({});

  return (
    <>
      <Button
        type="secondary"
        color="neutral"
        icon="efax-mono"
        text="Fax"
        onClick={() =>
          convertFormToPdf({
            setFaxData,
            setFaxLoading,
            setSendFaxModalVisible,
            itemProps: activeView?.itemProps,
            patientName: `${patient?.f_name} ${patient?.l_name}`
          })
        }
        loadingIcon={faxLoading}
        data-qa="print-btn"
      />
      {sendFaxModalVisible && (
        <SendFaxModal
          sendFaxModalVisible={sendFaxModalVisible}
          setSendFaxModalVisible={setSendFaxModalVisible}
          faxData={faxData}
        />
      )}
    </>
  );
};

export default SendFaxButton;
